<script setup>
import { RouterView } from 'vue-router'
import { ref, onBeforeMount } from 'vue'

import { useAuth } from '@/stores/auth'
import { useAccount } from '@/stores/account'

import SignupSurvey from './views/SignupSurvey.vue'
import AlertPopup from '@/components/elements/AlertPopup.vue'
import { useAlert } from '@/stores/alert'

const storeAlert = useAlert()

const auth = useAuth()
const account = useAccount()
const pageLoaded = ref(false)

onBeforeMount(async () => {
  pageLoaded.value = false
  if (auth.isLogged && auth.id) {
    await account
      .get(auth.id)
      .then(async () => {
        await showOnboarding()
      })
      .catch(() => {
        auth.logout()
      })
      .finally(() => {
        pageLoaded.value = true
      })
  } else {
    pageLoaded.value = true
  }
})

async function showOnboarding() {
  return auth.organization == 'None' ? true : false
}
</script>

<template>
  <div v-if="pageLoaded">
    <SignupSurvey v-if="showOnboarding == true" />
    <div v-else>
      <router-view v-slot="{ Component }">
        <Transition name="fade" mode="out-in">
          <component :is="Component" :key="$route.path"></component>
        </Transition>
      </router-view>

      <AlertPopup v-if="storeAlert.active" :message="storeAlert.text" :type="storeAlert.type" :title="storeAlert.title" />
    </div>
  </div>
  <MainLoader v-else class="flex h-screen items-center" />
</template>

<style scoped>
.fade-enter-active,
.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
